import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const objectToCSV = (obj, valueSeparator = '=', itemsSeparator = ',') =>
    Object.keys(obj).map(key => `${key}${valueSeparator}${obj[key]}`).join(itemsSeparator);

const flow = (...actions) => value => actions.reduce((args, action) => action(args), value);

const getWindowPosition = (options, opener) => ({
    top: ((opener.innerHeight - options.height) / 2) + opener.screenY,
    left: ((opener.innerWidth - options.width) / 2) + opener.screenX,
});

class ExternalAccount extends Component {
    componentWillMount() {
        const { type } = this.props;

        window.addEventListener('message', this.onMessage, false);

        if (type === 'window') {
            const {
                width,
                height,
                externalAccountUrl,
                windowName,
            } = this.props;
            const position = getWindowPosition({ width, height }, window);
            const configurationString = objectToCSV({
                ...position,
                width,
                height,
            });
            const newWindowInstance = window.open(
                externalAccountUrl,
                windowName,
                configurationString,
            );

            if (newWindowInstance) {
                newWindowInstance.focus();
            }
            const onTimerCheck = flow(
                this.checkIfWindowOpened,
            );
            const timerIdentifier = setInterval(onTimerCheck, 100);
            this.setState({
                newWindowInstance,
                timerIdentifier,
            });
        }
    }

    componentWillReceiveProps({
        type,
        width: newWidth,
        height: newHeight,
        externalAccountUrl: newExternalAccountUrl,
    }) {
        if (type === 'window') {
            const { newWindowInstance, isExternalAccountError } = this.state;
            if (newWindowInstance && !newWindowInstance.closed) {
                const {
                    width,
                    height,
                    externalAccountUrl,
                } = this.props;
                if (!newExternalAccountUrl || isExternalAccountError) {
                    clearTimeout(this.state.timerIdentifier);
                    newWindowInstance.close();
                }
                if (externalAccountUrl !== newExternalAccountUrl) {
                    newWindowInstance.location.href = newExternalAccountUrl;
                }
                if (width !== newWidth || height !== newHeight) {
                    newWindowInstance.resizeTo(newWidth, newHeight);
                    newWindowInstance.focus();
                }
            }
        }
    }

    componentWillUnmount() {
        const { type } = this.props;

        window.removeEventListener('message', this.onMessage, false);

        if (type === 'window') {
            const { newWindowInstance } = this.state;

            clearTimeout(this.state.timerIdentifier);
            if (newWindowInstance && !newWindowInstance.closed) {
                newWindowInstance.close();
            }
        } else {
            this.iframe.blur();
        }
    }

    onMessage = ({ data: { event, data } }) => {
        const { onExternalBackButtonClick, onLogout, onServerError } = this.props;

        if (
            (event === 'dashboard' || event === 'default') &&
            (data.success && onExternalBackButtonClick)
        ) {
            onExternalBackButtonClick();
        }
        if ((event === 'log-out') && data.success && onLogout) {
            onLogout();
        }
        if (event === 'serverError' && onServerError) {
            onServerError();
        }
    }

    onIframeSetRef = (node) => {
        this.iframe = node;
    }

    checkIfWindowOpened = () => {
        const { onExternalBackButtonClick } = this.props;
        const { newWindowInstance } = this.state;

        if (newWindowInstance && newWindowInstance.closed) {
            onExternalBackButtonClick();
        }
    }

    renderAccountInterface = () => {
        const { externalAccountUrl, type } = this.props;

        if (type === 'window') {
            const {
                newWindowInstance,
            } = this.state;
            const windowNotOpened = !newWindowInstance ||
                typeof newWindowInstance.closed === 'undefined';

            return windowNotOpened ?
                (
                    <span className="bs-externalAccount__error">
                        Please enable pop-ups in your web browser to view account
                    </span>
                )
                : null;
        }

        return (
            <div className="bs-externalAccount__wrapper">
                <iframe
                    ref={this.onIframeSetRef}
                    className="bs-iframeContainer"
                    src={externalAccountUrl}
                    title="accountInfo"
                />
            </div>
        );
    }

    render() {
        const { isExternalAccountError } = this.props;
        return isExternalAccountError ? (
            <span className="bs-externalAccount__error">
                Unable to access account details
            </span>
            ) : this.renderAccountInterface();
    }
}

ExternalAccount.defaultProps = {
    width: 750,
    height: 575,
    type: 'iframe',
    windowName: '',
    externalAccountUrl: '',
    isExternalAccountError: false,
    onExternalBackButtonClick: null,
    onLogout: null,
    onServerError: null,
};

ExternalAccount.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    type: PropTypes.string,
    windowName: PropTypes.string,
    externalAccountUrl: PropTypes.string,
    isExternalAccountError: PropTypes.bool,
    onLogout: PropTypes.func,
    onExternalBackButtonClick: PropTypes.func,
    onServerError: PropTypes.func,
};

export default ExternalAccount;



// WEBPACK FOOTER //
// /src/js/common/externalAccount/ExternalAccount.jsx